import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const BrowserRefreshIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M19.6 12c-.5 0-1 .4-1 .9 0 1.5-.7 3-1.7 4a6.3 6.3 0 0 1-3.8 2.2 6.6 6.6 0 0 1-7.3-3.9c-.5-1.4-.7-3-.3-4.4a6.6 6.6 0 0 1 2.4-3.6A6.3 6.3 0 0 1 12 5.8l2.3.1-1 1a1 1 0 0 0 0 1.3 1 1 0 0 0 1.5 0l2.4-2.5c.4-.4.4-1 0-1.4l-2.4-2.5a1 1 0 0 0-1.5 0 1 1 0 0 0 0 1.4l.7.7h-2a8.8 8.8 0 0 0-8.5 6.4 8.5 8.5 0 0 0 4.3 9.8 9 9 0 0 0 5.6.9c2-.4 3.7-1.3 5-2.8a8.5 8.5 0 0 0 2.2-5.2c0-.5-.4-1-1-1Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default BrowserRefreshIcon;
